export const fetchAllPages = async <TPage>(
  fetchPage: (page: number) => Promise<TPage>,
  hasNextPage: (lastPage: TPage, page: number) => boolean
): Promise<TPage[]> => {
  const pages: TPage[] = [];
  let page = 1;
  let hasMore = true;

  while (hasMore) {
    const lastPage = await fetchPage(page);
    pages.push(lastPage);
    hasMore = hasNextPage(lastPage, page);
    page += 1;
  }

  return pages;
};
